<template>
    <div class="footer">
        <div class="footer_inner">
            <img src="../assets/images/intro/logo.png" alt="" class="footer_logo">
            <div class="footer_socials">
                <a href="https://www.facebook.com/" target="_blank" class="footer_socials-item"><i class="fab fa-facebook-f --social"></i></a>
                <a href="https://www.ixbt.com/news/2020/07/06/google-google-currents.html" target="_blank" class="footer_socials-item"><i class="fab fa-google-plus-g --social"></i></a>
                <a href="https://twitter.com/?lang=ru" target="_blank" class="footer_socials-item"><i class="fab fa-twitter --social"></i></a>
                <a href="https://www.linkedin.com/in/dmytro-severenchuk-4425511ba/" class="footer_socials-item"><i class="fab fa-linkedin-in --social"></i></a>
                <a href="https://web.telegram.org/#/im" target="_blank" class="footer_socials-item"><i class="fab fa-telegram-plane --social"></i></a>
                <a href="https://www.pinterest.com/" target="_blank" class="footer_socials-item"><i class="fab fa-pinterest-p --social"></i></a>
                <a href="https://www.instagram.com/" target="_blank" class="footer_socials-item"><i class="fab fa-instagram --social"></i></a>
            </div>
            <div class="footer_text">© 2016 <span class="dark_text">Mulitix Theme</span> by ThemeForces. All Rights
                Reserved.</div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">

</style>